const TextInput = ({
  label,
  onChange = null,
  value = '',
  placeholder = '',
  inline = false,
  type = 'text',
  inputProps = {},
  unit = '',
}) => {
  return (
    <div
      className={`px-3 py-2 rounded-xl shadow ${
        inline ? 'flex items-center gap-2' : 'space-y-2'
      }`}
    >
      {label && (
        <label
          className={`text-gray-700 font-semibold ${
            inline ? 'min-w-20' : 'block min-w-14'
          }`}
        >
          {label}
        </label>
      )}
      <input
        type={type}
        className='w-full border-none '
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...inputProps}
      />
      {unit && <span>{unit}</span>}
    </div>
  );
};

export default TextInput;
